import axios from "axios";
import activities from "../../models/workflow/activities";
import licenseConcepts from "../../models/workflow/licenseConcepts";
import employees from "../../models/workflow/employees";
import filterAct from "../../models/workflow/filterAct";
import coments from "../../models/coments/coments";
import files from "../../models/workflow/files";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLicenseConcepts() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/workflow/conceptoslicencias`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return licenseConcepts.fromJson(item);
        });
      });
  }

  getEmployees() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const operid = Number(localStorage.getItem("operId"));

    return axios
      .get(`${url}/workflow/emp/${operid}`, {
        headers,
      })
      .then(({ data }) => {
        return data.map((item) => employees.fromJson(item));
      });
  }

  getActivities() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = localStorage.getItem("operId");
    return (
      axios
        .get(`${url}/workflow/actividades/${operid}`, { headers })
        // .get('https://private-c41b5-mvc4.apiary-mock.com/activities')
        .then(({ data }) => {
          return data.map((item) => {
            return activities.fromJson(item);
          });
        })
    );
  }
  getFilter() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const operid = localStorage.getItem("operId");
    return axios
      .get(`${url}/workflow/operfiltros/${operid}`, { headers })
      .then(({ data }) => {
        if (
          !data ||
          (typeof data === "object" && Object.keys(data).length === 0)
        ) {
          return {};
        }
        return filterAct.fromJson(data);
      });
  }
  getFiles(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/workflow/actividades/docs/${data.movimId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return files.fromJson(item);
        });
      });
  }
  saveFilter(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let dateTo = moment(data.to).format("YYYY-MM-DD");
    const operid = localStorage.getItem("operId");
    let payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      mios: data.mine,
      pendientes: data.pendings,
      aprobadas: data.approved,
      rechazadas: data.reject,
      licencias: data.licens,
      cHorario: data.schedules,
      hsExtra: data.hsExtra,
      licF: data.licF,
      dele: data.dele,
      columnas: data.columnas,
    };
    if (data.checkTo) {
      payload = {
        ...payload,
        nuncaExpira: data.checkTo,
      };
    } else if (!data.checkTo) {
      payload = {
        ...payload,
        fecHasta: data.to + "T00:00:00.000Z",
      };
    }
    return axios.put(`${url}/workflow/operfiltros/${operid}`, payload, {
      headers,
    });
  }

  async newAct(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    await Promise.all(
      data.map(async (element) => {
        payload = {
          tipo: element.tipoProceso,
          movimId: parseInt(element.movimId, 10),
          operId: parseInt(operid, 10),
          aprobado: element.approved,
          cantAut: element.cantAut,
          cantNoAut: element.cantNoAut,
          comentario: element.comentario,
        };

        if (element.hasOwnProperty("cantCC")) {
          payload.cantCC = element.cantCC;
        }

        await axios.post(`${url}/workflow/actividades/act`, payload, {
          headers,
        });
      })
    );
  }
  async undo(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    await Promise.all(
      data.map(async (element) => {
        payload = {
          movimId: parseInt(element.movimId, 10),
          operId: parseInt(operid, 10),
        };
        await axios.post(`${url}/workflow/actividades/undo`, payload, {
          headers,
        });
      })
    );
  }
  async newScheduleAct(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      empId: parseInt(data.employees, 10),
      horarioId: parseInt(data.scheduleId, 10),
      segmId: parseInt(data.segmentId, 10),
      numSecuencia: parseInt(data.sequenceNumber, 10),
      segmDespl: parseInt(data.initialDay, 10),
      fecDesde: data.from + "T00:00:00.000Z",
      fecHasta: data.to == null ? undefined : data.to + "T00:00:00.000Z",
    };

    if (data.certificateFile) {
      payload.docAdjunto = data.certificateFile;
    }
    return axios.post(`${url}/workflow/actividades/cambiohorario`, payload, {
      headers,
    });
  }
  async newLicAct(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      empId: parseInt(data.emp, 10),
      conceptoId: parseInt(data.concept, 10),
      csCostoId: parseInt(data.costo, 10),
    };

    const hasTime = data.timeFrom != null && data.timeTo != null;

    if (hasTime) {
      payload.desde = `${data.from}T${data.timeFrom}:00.000Z`;
      payload.hasta = `${data.to}T${data.timeTo}:00.000Z`;
    } else {
      payload.desde = `${data.from}T00:00:00.000Z`;
      payload.hasta = `${data.to}T00:00:00.000Z`;
    }

    if (data.certificateFile) {
      payload.docAdjunto = data.certificateFile;
    }

    return axios.post(`${url}/workflow/actividades/pedidolicencia`, payload, {
      headers,
    });
  }

  getComents() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/coments/autoriz`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return coments.fromJson(item);
      });
    });
  }
}

export default service;
